import axios from "axios";
import store from "@/store";
import router from "@/router/index";
import Url from "@/components/api/url";
import { Toast } from 'vant';
axios.defaults.baseURL = Url.baseURL
axios.defaults.timeout = 60000//请求超时时间(毫秒)
axios.interceptors.request.use(config => {
    if (JSON.parse(localStorage.getItem("userInfo"))) {
        //判断浏览器中的cookie中是否存在项目的token
        config.headers.token = JSON.parse(localStorage.getItem("userInfo")).token
    }
    return config
}, err => {
    return Promise.reject(err); //请求错误处理
})
if (!localStorage.getItem("kefu")) {
    store.state.flags = true
    store.state.flag1 = false
} else {
    store.state.flags = false
    store.state.flag1 = false
}
axios.interceptors.response.use(response => {
    if (response.status == 200 || response.status == 'succeeded') {
		sessionStorage.removeItem('isIndexWH')
        if (response.data != undefined && response.data.status != undefined) {
            store.state.shows = false
            store.state.show = false
            if (response.data.status == 200  || response.data.status == 'succeeded' || response.data.status == 'pending') {
            } else if (response.data.status === 400 && response.config.url.indexOf("im/getUnreadMsgNum") == -1) {
                if (response.config.url.indexOf("buyer/info") != -1) {
                    clearTimeout(store.state.timers)
                    localStorage.removeItem("userInfo")
                    store.state.userInfo = null
                    store.state.buyerId = null
                } else if (response.config.url.indexOf("im/getMsgShop") != -1) {
                    clearTimeout(store.state.timers)
                    localStorage.removeItem("userInfo")
                    store.state.userInfo = null
                    store.state.buyerId = null
                } else if (response.config.url.indexOf("buyerCredit/getBuyerCredit") != -1) {
                    clearTimeout(store.state.timers)
                    localStorage.removeItem("userInfo")
                    store.state.userInfo = null
                    store.state.buyerId = null
                } else if (response.config.url.indexOf("information/payResult") != -1) {
                    clearTimeout(store.state.timers1)
                    localStorage.removeItem("userInfo")
                    store.state.userInfo = null
                    store.state.buyerId = null
                } else {
                    store.state.flags = false
                    clearTimeout(store.state.timers)
                    Toast("登录过期!")
                    store.state.userInfo = null
                    store.state.buyerId = null

                    router.push("/login")
                }
            } else {
                store.state.shows = false
                store.state.show = false
                if (response.config.url == "buyer/info/") {
                } else if (response.config.url.indexOf("information/payResult") != -1) {

                } else {
                    if (response.data.message == null) {
                        Toast("数据异常，请联系管理员~")
                    } else if (response.data.message == "" || response.data.message == undefined) {

                    } else if(response.data.message.indexOf('Error') != '-1'){
						
					} else {
                        Toast(response.data.message)
                    }
                    // Toast(response.data.message == null ? "数据异常，请联系管理员" : response.data.message);
                }
            }
        }
    } else {
        store.state.shows = false
        store.state.show = false
        if (response.data.message == null) {
            Toast("数据异常，请联系管理员!")
        } else if (response.data.message == "" || response.data.message == undefined) {

        } else if(response.data.message.indexOf('Error') != '-1'){
						
		} else {
            Toast(response.data.message)
        }
        // Toast(response.message == null ? "数据异常，请联系管理员" : response.message)
    }
    return Promise.resolve(response);
}, err => {
	if(err && err.response) {
		if(err.response.status == 886) {
			sessionStorage.setItem('isIndexWH',true)
			router.push("/indexWH")
		}
	}
    store.state.shows = false
    store.state.show = false
    if (err.stack.indexOf('timeout') < -1) {
        Toast('请求超时')
        return Promise.reject(err);
    }
    return Promise.reject(err);
})
var myAjax = {
    get(url) {
        return new Promise((resolve, reject) => {
            axios.get(url).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
    post(url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, params).then(res => { resolve(res) }).catch(err => { reject(err) });
        });
    },
    delete(url, params) {
        return new Promise((resolve, reject) => {
            axios.delete(url, params).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
    put(url, params) {
        return new Promise((resolve, reject) => {
            axios.put(url, params).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
	
	postJson(url,params) {
		return new Promise((resolve, reject) => {
		        const formData = new FormData();
		        // 将参数 params 添加到 formData 中
		        for (let key in params) {
		            formData.append(key, params[key]);
		        }
		        axios.post(url, formData, {
		            headers: {
		                'Content-Type': 'multipart/form-data'
		            }
		        }).then(res => {
		            resolve(res);
		        }).catch(err => {
		            reject(err);
		        });
		    });
	}
}
export default myAjax


// WEBPACK FOOTER //
// ./src/components/api/http.js